<template>
  <div v-if="isOpenFloat&&!isMinimizedFloat" class="materials-tele">
    <div class="materials-tele-inner">
      <div class="materials-tele-title">
        <div>批量提审素材</div>
        <CompressOutlined style="cursor:pointer;" @click="folders(true)" />
      </div>
      <div style="display:flex">
        <span style="flex-shrink: 0;font-size:14px;padding-top:5px;">上传图片、视频文件夹：</span>
        <UploadFolders ref="uploadFoldersRef" @finished="handleOk" />
      </div>
      <div style="margin-top:10px;display:flex">
        <span style="flex-shrink: 0;font-size:14px;padding-top:5px;">上传提审列表：</span>
        <div>
          <a-upload
            v-model:file-list="fileList"
            name="avatar"
            :show-upload-list="false"
            :customRequest="handleUpload"
          >
            <a-button type="primary">{{fileList.length?'重新上传文件':'上传文件'}}</a-button>
          </a-upload>
          <a-button style="margin-left: 20px;" @click="handleViewTemp">下载模版</a-button>
          <div style="font-size:14px;margin-top:10px;">
            <div v-for="(item,index) in fileList" :key="index">
              <span>{{ item.name }}</span>
              <CloseCircleOutlined style="cursor:pointer;margin-left: 20px;color: blue;font-weight: bold;" @click="clearFiles" />
            </div>
          </div>
        </div>
      </div>

      <div style="font-size:14px;margin-top:20px;font-weight:bold;">{{ progress }}</div>
      <div style="margin-top: 10px;">
        <div v-if="errorLists && errorLists.length">
          <div style="color:red;font-size:14px;margin-top:20px;font-weight: bold;color:red;"><span tag="mark">❗️错误信息</span><a-button style="padding-left:20px" @click="copyMessage" class="copy-button" type="primary">复制</a-button></div>
          <div style="font-size: 12px;white-space: pre-wrap;word-break:break-all;max-height: 200px;overflow: auto;margin-top: 8px;border: 1px solid #eee; border-radius: 4px; padding: 4px 8px; line-height: 1.5;color:red;">
            <div v-for="item in errorLists" :key="item">{{item}}</div>
          </div>
        </div>
      </div>
      <div style="display:flex;gap:10px;justify-content:flex-end;margin-top:20px;">
        <a-button type="primary" :loading="loading" @click="handlePreview">生成预览数据</a-button>
        <a-button type="primary" :loading="loading" v-if="showSubmit" @click="startUpload">确认提交</a-button>
        <a-button key="back" @click="onCancle">关闭</a-button>
      </div>
    </div>

  </div>
 
  <div class="materials-tele-mini" v-if="isOpenFloat&&isMinimizedFloat">
    <div class="materials-tele-mini-inner">
      <div><a-tag color="green" v-if="action">{{action}}</a-tag> <span style="padding-left:5px;">{{ progress }}</span></div>
      <ExpandOutlined style="cursor:pointer;" @click="folders(false)" />
    </div>
  </div>

  <a-modal v-model:open="showSuccessTips" title="Basic Modal" @ok="handleOk">
    <p>Some contents...</p>
    <p>Some contents...</p>
    <p>Some contents...</p>
  </a-modal>
</template>

<script lang='ts' setup>
import ClipboardJS from 'clipboard'
import { h, ref, computed, getCurrentInstance, nextTick} from 'vue';
import request from '@/utils/request'
import { message,Modal,notification, Button } from 'ant-design-vue';
import { useStore } from 'vuex'
import UploadFolders from './UploadFolders.vue'
import {CompressOutlined, ExpandOutlined, CloseCircleOutlined} from '@ant-design/icons-vue'
import { useRouter } from 'vue-router';

const router = useRouter()
const { proxy } = getCurrentInstance();

const fileList = ref([])
const files = ref([])
const loading = ref(false)
const showSuccessTips = ref(false)
const confirmUrl = ref('')

const isPreview = ref(true)
const showSubmit = ref(false)

const store = useStore()
const isOpenFloat = computed(() => store.state.isOpenFloat)
const isMinimizedFloat = computed(() => store.state.isMinimizedFloat)

const action = ref('处理中...')
const progress = ref('')
const errorLists = ref([])
const successData = ref(null)

function show() {
  files.value = []
  clearFiles()
  nextTick(() => {
    proxy.$refs.uploadFoldersRef?.resetState()
  })
}
function folders (value) {
  store.commit('setIsMinimizedFloat', value)
}
function clearFiles() {
  loading.value = false
  fileList.value = []
  confirmUrl.value = ''
  isPreview.value = true
  showSubmit.value = false
  action.value = '处理中...'
  progress.value = ''
  errorLists.value = []
  successData.value = null
}
async function handleUpload(file) {
  if (!file.file) {
      message.error("请选择文件")
      return
  }
  fileList.value = [file.file]
  loading.value = true
  request.upload(`/api/in/kol/cpe/file/upload_excel`, file.file, 'no').then((rsp: any) => {
    console.log('rsp', rsp)
    confirmUrl.value = rsp.url
    loading.value = false
    isPreview.value = true
    showSubmit.value = false
  }).catch(() => loading.value = false)
  
}
function handlePreview() {

  action.value = '处理中...'
  progress.value = ''
  errorLists.value = []
  successData.value = null

  let files = proxy.$refs.uploadFoldersRef.fileList
  if(!files.length) {
    return message.error("请上传图片、视频文件夹")
  }
  if (!confirmUrl.value) return message.error("请上传excel文件")
  let images = files.map(v=> ({fileName: v.name}))
  startStreaming(images)
}
async function startStreaming (images) {
  const controller = new AbortController();
  const { signal } = controller;

  const timeoutId = setTimeout(() => {
    controller.abort(); // 中止请求
    
    loading.value = false
    isPreview.value = true
    showSubmit.value = false

    console.error("连接超时，已重置变量");
  }, 30000);
  loading.value = true
  try {
    const response = await fetch('/api/in/kol/cpe/admin/material_approval/prepare_batch_add_material2', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json','Accept': 'text/event-stream', },
      // dataType:"text/event-stream",
      body: JSON.stringify({excelFileUrl: confirmUrl.value, imageFileList: images}),
      signal,
    });
    console.log('response', response)
    // 2. 一旦服务器响应了（Header已收到），就清除定时器
    clearTimeout(timeoutId);

    if (!response.body) return;

    console.log('response.body', response.body)
    const reader = response.body.getReader();
    const decoder = new TextDecoder();

    // 缓存残缺的分片（防止一个 JSON 被横跨两个 chunk 切断）
    let leftovers = ''; 

    while (true) {
      const { value, done } = await reader.read();
      if (done) break;
      console.log(9999, value, done)
      // 将二进制转为文本，并加上上次剩下的残余部分
      const chunk = leftovers + decoder.decode(value, { stream: true });
      
      // 按换行符分割
      const lines = chunk.split('\n');
      
      // 最后一行可能是不完整的，先存起来下次拼上
      leftovers = lines.pop() || '';

      for (const line of lines) {
        const trimmedLine = line.trim();
        
        // 关键：只处理 data: 开头的行
        if (trimmedLine.startsWith('data:')) {
          // 提取 data: 后面的内容
          const dataContent = trimmedLine.replace(/^data:\s*/, '');
          
          if (dataContent === '[DONE]') {
            console.log("传输结束");
            break;
          }

          try {
            // 如果 data 后面是 JSON 字符串，解析它
            const parsed = JSON.parse(dataContent);
            console.log("拿到纯数据:", parsed);
            action.value = parsed.action
            if (parsed.action=='结束') {
              loading.value = false
              isPreview.value = false
              errorLists.value = parsed.error.split('\n').filter(Boolean)
              if (errorLists.value.length) {
                showSubmit.value = false
              }
              if (parsed.error && parsed.message=='失败') {
                isPreview.value = true
                showSubmit.value = false
              }
              if (parsed.data && parsed.message=='成功') {
                successData.value = parsed.data
                showSubmit.value = true
              }
              break
            }
            if (parsed.action=='进行中') {
              progress.value = parsed.progress.text
              if (parsed.error) {
                errorLists.value.push(parsed.error) 
              }
            }
            // 假设你要的数据在 content 字段里
            // yourRef.value += parsed.content; 
          } catch (e) {
            // 如果 data 后面只是普通字符串而非 JSON
            console.log("纯文本数据:", dataContent);
            // yourRef.value += dataContent;
          }
        }
      }
    }
  } catch(err) {
    console.log(err)
    message.error("连接超时，请检查。")
    loading.value = false
    isPreview.value = true
    showSubmit.value = false
  }
}
function startUpload() {
  // console.log(successData.value)
  // if (!successData.value) {
  //   return message.error("暂无可提交的信息")
  // }
  loading.value=true
  proxy.$refs.uploadFoldersRef.initOSSClient()
}
function handleOk() {
  let errorMessage = errorLists.value.length
  let title = errorMessage ? '❗️存在错误信息' : '是否确认提交?'
  Modal.confirm({
    content: () => title,
    onOk: () => {
      loading.value = true
      let successes = proxy.$refs.uploadFoldersRef.successFiles
      let images = successes.map(v=> ({fileName: v.fileName, url: v.url}))
      request.post(`/api/in/kol/cpe/admin/material_approval/batch_add_material2`, {data: successData.value, excelFileName:fileList.value[0].name, excelFileUrl: confirmUrl.value, imageFileList: images}, '操作成功', {
        
      }).then((rsp) => {
        console.log(1111, rsp);
        if (rsp.code==200) {
          onCancle()
          onTip()
          store.commit('setIsmaterialSuccess', true)
        } 
        
        loading.value = false
      }).catch(()=>loading.value = false)
    },
    onCancel() {
      loading.value=false
      Modal.destroyAll();
    },
  });
  
}
function onCancle() {
  show()
  folders(false)
  store.commit('setIsOpenFloat', false)

}
const handleViewTemp = async () => {

  try {
    const response = await fetch('/templates/template-material.xlsx');
    if (!response.ok) throw new Error('文件不存在');
    
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = '批量提审素材.xlsx';
    link.click();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    // 
  }
}

function onTip() {
  const key = `open${Date.now()}`;
  notification.open({
    message: '提示',
    description:'后台任务处理中, 请前往任务中心查看进度',
    btn: () =>
      h(
        Button,
        {
          type: 'primary',
          size: 'small',
          onClick: () => {
            router.push({name:'TaskCenter'})
            if (!isMinimizedFloat.value) {
              folders(true)
            }
            notification.close(key)
          },
        },
        { default: () => '立即查看' },
      ),
    key,
    onClose: close,
  });
}

const copyMessage = (text) => {
  new ClipboardJS('.copy-button', {
    text: function (trigger) {
      return errorLists.value.join('\n')
    },
  })
}
</script>
<style lang="scss">
.materials-tele {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,.5);
  z-index: 100;

  .materials-tele-inner {
    background-color: #fff;
    border-radius: 6px;
    width: 70%;
    margin: 50px auto;
    padding: 20px;
    max-height: 80%;
    overflow: auto;
  }
  .materials-tele-title {
    color: rgba(0, 0, 0, 0.88);
    font-weight: 600;
    font-size: 16px;
    line-height: 1.5;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }
}
.materials-tele-mini {
  position: fixed;
  top: 44px;
  right: 10px;
  background: linear-gradient(278deg, rgb(249, 143, 255) 0%, rgb(209, 145, 255) 30%, rgb(163, 160, 255) 60%, rgb(130, 190, 255) 100%);
  background: #dbe6e0;
  box-shadow: 0 0 1px rgba(0,0,0,0.3),0 4px 14px rgba(0,0,0,0.1);
  border-radius: 3px;
  z-index: 100;
  padding: 8px 10px;
  .materials-tele-mini-inner {
    display: flex;
    font-size:12px;
    font-weight: bold;
    gap:30px;

  }
}
</style>